import "./ReservationInquiry.module.css";
import Header from "@/reusable_sections/Header";
import ReserveIntro from "./sections/ReserveIntro";
import ContactFormSection from "./sections/ContactFormSection";
import Footer from "@/reusable_sections/Footer";
export default function ReservationInquiryPage() {
  return <div>
      <Header />
      <ReserveIntro />
      <ContactFormSection />
      <Footer />
    </div>;
}